import ApiService from "./base";
import { config } from "@/utils/config";
export default class ContractsService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getContractsByCustomer(productCode, customerId) {
        const params = new URLSearchParams();
        if (productCode) params.append("productCode", productCode);
        if (customerId) params.append("customerId", customerId);
        const url = `/direct/contracts${params.toString() ? `?${params.toString()}` : ""}`;
        const response = await this.get({
            url
        });
        return response.data;
    }
    async getAllPricingPolicies() {
        const response = await this.get({
            url: "/direct/pricing-policies"
        });
        return response.data;
    }
    async createContract(data) {
        const response = await this.post({
            url: "/direct/contracts",
            data
        });
        return response.data;
    }
    async reissueResolveToken(contractId, resolveTokenExpiryHours = 24) {
        const response = await this.post({
            url: `/direct/contracts/${contractId}/resolve-token/reissue`,
            data: {
                resolveTokenExpiryHours
            }
        });
        return response.data;
    }
}
